import React from "react";

const LANGS = [
  { id: "es", label: "ES", name: "Español" },
  { id: "en", label: "EN", name: "English" },
  { id: "la", label: "LA", name: "Latín" },
];

export default function DictationLangToggle({ value, onChange, disabled }) {
  const active = LANGS.find((l) => l.id === value) || LANGS[0];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3px",
        flexShrink: 0,
      }}
      title={`Idioma de dictado: ${active.name}`}
      aria-label="Idioma de dictado"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
          padding: "3px",
          borderRadius: "12px",
          background: "rgba(0,0,0,0.34)",
          border: "1px solid rgba(212,175,55,0.22)",
          boxShadow: "0 0 18px rgba(0,0,0,0.25)",
        }}
      >
        {LANGS.map((l) => {
          const isActive = value === l.id;
          return (
            <button
              key={l.id}
              type="button"
              disabled={disabled}
              onClick={() => onChange(l.id)}
              aria-pressed={isActive}
              aria-label={`Dictar en ${l.name}`}
              title={`Dictar en ${l.name}`}
              style={{
                minWidth: "34px",
                minHeight: "32px",
                padding: "0 7px",
                border: isActive ? "1px solid rgba(212,175,55,0.8)" : "1px solid transparent",
                borderRadius: "9px",
                background: isActive ? "rgba(212,175,55,0.22)" : "transparent",
                color: isActive ? "#F8D879" : "rgba(255,255,255,0.58)",
                cursor: disabled ? "not-allowed" : "pointer",
                fontSize: "0.68rem",
                fontWeight: 900,
                lineHeight: 1,
                letterSpacing: "0.04em",
                transition: "background 0.16s ease, color 0.16s ease, border-color 0.16s ease, transform 0.12s ease",
                transform: isActive ? "translateY(-1px)" : "none",
              }}
            >
              {l.label}
            </button>
          );
        })}
      </div>
      <span
        style={{
          color: "rgba(255,255,255,0.52)",
          fontSize: "0.55rem",
          fontWeight: 800,
          letterSpacing: "0.06em",
          lineHeight: 1,
          textTransform: "uppercase",
          pointerEvents: "none",
        }}
      >
        Dictado
      </span>
    </div>
  );
}
